import { render } from "./UpdateBanner.vue?vue&type=template&id=3236de16&scoped=true"
import script from "./UpdateBanner.vue?vue&type=script&lang=js"
export * from "./UpdateBanner.vue?vue&type=script&lang=js"

import "./UpdateBanner.vue?vue&type=style&index=0&id=3236de16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3236de16"]])

export default __exports__